var map = {
	"./ar.json": 5284,
	"./bg.json": 9725,
	"./de.json": 7480,
	"./el.json": 2984,
	"./en.json": 3482,
	"./es.json": 3063,
	"./hr.json": 2276,
	"./hu.json": 217,
	"./hy.json": 1023,
	"./it.json": 2989,
	"./ja.json": 5548,
	"./kk.json": 1370,
	"./ko.json": 7124,
	"./nl.json": 9376,
	"./no.json": 6444,
	"./pt.json": 342,
	"./ru.json": 5521,
	"./sk.json": 5964,
	"./sl.json": 9786,
	"./zh-cn.json": 653,
	"./zh-hk.json": 7555,
	"./zh-tw.json": 2321
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3251;